import React from "react";
import { Link } from "./Link";
import { ExternalLinkIcon } from "@heroicons/react/outline";
import { CalendarIcon } from "@heroicons/react/outline";

const story = {
  title: "TextLink Text",
  component: Link,
};

export default story;

export const TextLinkXl = Link.bind({});
TextLinkXl.args = {
  label: "Textlink Extra Large",
  size: "xl",
  theme: "light",
  leadingIcon: <CalendarIcon />,
  trailingIcon: <ExternalLinkIcon />,
};

export const TextLinkLg = Link.bind({});
TextLinkLg.args = {
  label: "Textlink Large",
  size: "lg",
  leadingIcon: <CalendarIcon />,
  trailingIcon: <ExternalLinkIcon />,
};

export const TextLinkMd = Link.bind({});
TextLinkMd.args = {
  label: "Textlink Medium",
  size: "md",
  leadingIcon: <CalendarIcon />,
  trailingIcon: <ExternalLinkIcon />,
};

export const TextLinkSm = Link.bind({});
TextLinkSm.args = {
  label: "Textlink Small",
  size: "sm",
  leadingIcon: <CalendarIcon />,
  trailingIcon: <ExternalLinkIcon />,
};

export const TextLinkDark = () => (
  <div className="flex h-[45px] w-fit items-center bg-black">
    <Link
      leadingIcon={<CalendarIcon />}
      trailingIcon={<ExternalLinkIcon />}
      theme="dark"
      size="xl"
    >
      TextLink Dark
    </Link>
  </div>
);

export const TextLinkNoIcons = Link.bind({});
TextLinkNoIcons.args = {};
